import removeExtraSubFieldsHelper from '../helpers/removeExtraSubFieldsHelper';

const reverseTransform = article => ({ ...removeExtraSubFieldsHelper(article, ['category']) });

export { reverseTransform };
